import React from "react";
import { ReportGrid } from "../../../components/ReportGrid"; 
import { BarChart3 } from "lucide-react";
import { useReportStore } from "../../../store/raporStore";
import { DatePicker } from "../../../components/DatePicker";

export const SalesAnalysis = () => {
  const { filters, setFilters } = useReportStore();

  const performanceColumns = [
    { header: "Stok Kodu", field: "sku" },
    { header: "Ürün Adı", field: "stockName" },
    { header: "Toplam Miktar", body: (row: any) => (
      <span className="font-semibold">{row._sum?.quantity} Adet</span>
    )},
    { header: "Toplam Ciro", body: (row: any) => (
      <span className="font-bold">
        {row._sum?.totalAmount?.toLocaleString('tr-TR')} ₺
      </span>
    )},
    { 
      header: "Performans", 
      body: () => (
        <div className="w-full bg-slate-100 rounded-full h-1.5 max-w-[80px]">
          <div className="bg-blue-600 h-1.5 rounded-full" style={{ width: '100%' }}></div>
        </div>
      )
    },
  ];

  const DateFilterArea = (
    <div className="flex items-center gap-2 no-print">
      <DatePicker
        name="startDate"
        label=""
        value={filters.startDate}
        className="min-w-48"
        onChange={(val: any) => setFilters({ ...filters, startDate: val?.target ? val.target.value : val })}
      />
      <span className="text-slate-300 font-light">/</span>
      <DatePicker
        name="endDate"
        label=""
        value={filters.endDate}
        className="min-w-48"
        onChange={(val: any) => setFilters({ ...filters, endDate: val?.target ? val.target.value : val })}
      />
    </div>
  );

  return (
    <div className="space-y-6">
      <div className="flex flex-col card lg:flex-row lg:items-center justify-between gap-4">
        <div>
          <h1 className="text-sm sm:text-2xl font-black flex items-center gap-3">
            <div className="p-2 bg-blue-600 text-white rounded-xl shadow-lg">
              <BarChart3 size={20} />
            </div>
            Satış ve Karlılık Analizi
          </h1>
          <p className="text-sm mt-1 opacity-70">Ürün bazlı ciro ve miktar performansını inceleyin.</p>
        </div>
      </div>

      <div className="  ">
        <ReportGrid 
          endpoint="/reports/sales/performance" 
          columns={performanceColumns} 
          filters={filters}
          reportName="Satış Performans Raporu"
          extraFilters={DateFilterArea}
        />
      </div>
    </div>
  );
};